<template>
        <div
          v-if="a.requiredCardsRest.length"
          class="required-block required-block-rest"
        >
          <h6 class="required-block-title">
            مرفقات إضافية
          </h6>
          <div class="d-flex flex-wrap required-block-cards">
            <!-- Special handling for "مرفقات اضافية" - show all files -->
            <template v-for="card in a.requiredCardsRest">
              <!-- Multiple files display for "مرفقات اضافية" -->
              <div
                v-if="card.key === 'مرفقات اضافية' && card.isMultiple"
                :key="`multiple-${card.key}`"
                class="w-100 mb-3"
              >
                <b-card class="shadow-sm">
                  <div class="d-flex justify-content-between align-items-center mb-2">
                    <h6 class="mb-0">
                      {{ card.key }}
                    </h6>
                    <b-badge variant="info">
                      {{ card.files_count }} ملف
                    </b-badge>
                  </div>

                  <!-- Upload Section -->
                  <div class="mb-3">
                    <b-form-file
                      v-model="a.requiredUploads[card.key]"
                      :disabled="a.isUploadDisabledByTeam(card.key)"
                      :state="Boolean(a.requiredUploads[card.key])"
                      placeholder="اختر ملف أو أكثر"
                      drop-placeholder="اسحب الملفات هنا"
                      browse-text="تصفح"
                      multiple
                      :accept="a.getAcceptExtensions(card.key)"
                    />
                    <small
                      v-if="a.isUploadDisabledByTeam(card.key)"
                      class="text-danger d-block mt-1"
                    >يجب اضافة الفريق اولا</small>
                    <b-button
                      class="mt-2 w-100"
                      size="sm"
                      variant="primary"
                      :disabled="a.isUploadDisabledByTeam(card.key) || !a.requiredUploads[card.key] || a.isUploadingRequired(card.key)"
                      @click="a.submitRequiredMultiple(card.key)"
                    >
                      <b-spinner
                        v-if="a.isUploadingRequired(card.key)"
                        small
                        class="mr-1"
                      />
                      إضافة ملفات
                    </b-button>
                  </div>

                  <!-- Files List -->
                  <div
                    v-if="card.files && card.files.length > 0"
                    class="files-list d-flex flex-wrap"
                  >
                    <b-card
                      v-for="file in card.files"
                      :key="file.id"
                      class="media-card mb-2 shadow-sm"
                      body-class="p-1 d-flex flex-column align-items-center"
                      
                    >
                      <!-- Collection checkbox for projectType 168 -->
                      <div
                        v-if="a.isProject168"
                        class="media-select-checkbox"
                      >
                        <b-form-checkbox
                          :checked="a.isCollectionSelected(file)"
                          @change="a.onCollectionCheckboxChange(file, $event)"
                        />
                      </div>

                      <!-- File preview -->
                      <div class="media-card-thumb mb-1">
                        <img
                          v-if="file.is_image"
                          :src="file.url"
                          alt="preview"
                          class="media-thumb-img"
                        >
                        <div v-else-if="file.is_document && file.extension === 'pdf'">
                          <b-icon
                            icon="file-earmark-pdf"
                            variant="danger"
                            font-scale="3.2"
                            class="my-3"
                          />
                        </div>
                        <div v-else-if="file.is_video">
                          <b-icon
                            icon="camera-video"
                            variant="primary"
                            font-scale="3.2"
                            class="my-3"
                          />
                        </div>
                        <div v-else>
                          <b-icon
                            icon="file-earmark"
                            variant="secondary"
                            font-scale="3.2"
                            class="my-3"
                          />
                        </div>
                      </div>

                      <div class="media-file-details w-100 text-center mb-2">
                        <div
                          class="file-title"
                          style="word-break:break-all"
                        >
                          {{ file.file_name || file.name }}
                        </div>
                        <div class="file-meta text-muted small mt-1">
                          {{ (file.extension || '').toUpperCase() }} • {{ file.human_readable_size }}
                        </div>
                        <div class="file-meta text-muted small mt-1">{{ file.uploader ? file.uploader.name : '' }}
                        </div>
                        <div class="file-meta text-muted small mt-1">{{ file.created_at | formatJalali }}
                        </div>
                      </div>

                      <!-- Notes Section -->
                      <div class="media-card-notes w-100 ">
                        <div
                          v-if="!a.editingNotes[file.id]"
                          class="notes-display"
                        >
                          <div
                            v-if="file.notes"
                            class="notes-content"
                          >
                            <p class="notes-text mb-0">
                              {{ file.notes }}
                            </p>
                          </div>

                        </div>
                        <div
                          v-else
                          class="notes-edit"
                        >
                          <b-form-textarea
                            v-model="a.notesEdit[file.id]"
                            placeholder="أدخل الملاحظات..."
                            rows="3"
                            class=""
                            :disabled="a.savingNotes[file.id]"
                          />
                          <div class="d-flex gap-1">
                            <b-button
                              size="sm"
                              variant="primary"
                              class="flex-fill"
                              :disabled="a.savingNotes[file.id]"
                              @click="a.saveNote(file)"
                            >
                              <b-spinner
                                v-if="a.savingNotes[file.id]"
                                small
                                class="mr-1"
                              />
                              حفظ
                            </b-button>
                            <b-button
                              size="sm"
                              variant="outline-secondary"
                              class="flex-fill"
                              :disabled="a.savingNotes[file.id]"
                              @click="a.cancelEditingNote(file.id)"
                            >
                              إلغاء
                            </b-button>
                          </div>
                        </div>
                      </div>

                      <!-- Actions -->
                      <div class="media-card-actions d-flex flex-row justify-content-center gap-1 w-100 ">
                        <b-button
                          v-if="file.is_image || file.is_video || file.is_document"
                          v-b-tooltip.hover.top="'معاينة'"
                          :href="file.url"
                          target="_blank"
                          size="sm"
                          variant="info"
                        >
                          <feather-icon icon="EyeIcon" size="12" />
                        </b-button>
                        <b-button
                          v-if="a.hasPermission('download media')"
                          v-b-tooltip.hover.top="'تحميل'"
                          :href="file.download_url"
                          target="_blank"
                          size="sm"
                          variant="success"
                        >
                          <feather-icon icon="DownloadIcon" size="12" />
                        </b-button>
                        <b-button
                          v-if="a.hasPermission('delete media')"
                          v-b-tooltip.hover.top="'حذف'"
                          size="sm"
                          variant="danger"
                          @click="a.deleteFile(file.id)"
                        >
                          <feather-icon icon="Trash2Icon" size="12" />
                        </b-button>
                        <b-button
                          v-if="!a.editingNotes[file.id] && a.hasPermission('edit projects')"
                          v-b-tooltip.hover.top="file.notes ? 'تعديل الملاحظات' : 'إضافة ملاحظات'"
                          size="sm"
                          variant="outline-secondary"
                          @click="a.startEditingNote(file)"
                        >
                          <feather-icon icon="EditIcon" size="12" />
                        </b-button>
                      </div>
                    </b-card>
                  </div>
                  <div
                    v-else
                    class="text-muted text-center py-3"
                  >
                    لا توجد ملفات مرفوعة بعد
                  </div>
                </b-card>
              </div>

              <!-- Regular single file card for other types -->
              <attachment-media-card
                v-else
                :key="`required-${card.key}`"
                :title="card.key"
                :file="card.file"
                :upload-value="a.requiredUploads[card.key]"
                upload-layout="stacked"
                :upload-disabled="a.isUploadDisabledByTeam(card.key)"
                :show-team-disabled-message="a.isUploadDisabledByTeam(card.key)"
                :accept="a.getAcceptExtensions(card.key)"
                :uploading="a.isUploadingRequired(card.key)"
                :is-cad-ark="card.key === 'ملف CAD من الارك'"
                card-margin-class=""
                :show-collection-checkbox="a.isProject168 && Boolean(card.file)"
                :collection-selected="Boolean(card.file && a.isCollectionSelected(card.file))"
                :editing-note="a.isFileNoteEditing(card.file)"
                :note-draft="a.getFileNoteDraft(card.file)"
                :saving-note="a.isFileNoteSaving(card.file)"
                @update:upload-value="a.setRequiredUpload(card.key, $event)"
                @submit-upload="a.submitRequired(card.key)"
                @delete="a.deleteFile(card.file.id)"
                @save-note="a.saveNote(card.file)"
                @cancel-edit-note="a.cancelEditingNote(card.file.id)"
                @start-edit-note="a.startEditingNote(card.file)"
                @update:note-draft="a.setFileNoteDraft(card.file, $event)"
                @collection-change="a.onCollectionCheckboxChange(card.file, $event)"
              />
            </template>
          </div>
        </div>
</template>

<script>
import attachmentsBlockMixin from '../attachmentsBlockMixin'

export default {
  name: 'AttachmentsBlockRest',
  mixins: [attachmentsBlockMixin],
}
</script>

<style src="../attachments-shared.scss" lang="scss"></style>
